import { render, staticRenderFns } from "./HighRiskUserProfilingTable.vue?vue&type=template&id=5fe710d2"
import script from "./HighRiskUserProfilingTable.vue?vue&type=script&lang=js"
export * from "./HighRiskUserProfilingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports